module.exports = __webpack_public_path__ + "static/media/Screen 1_Detailed Event.7fb45668.png";